import { Routes } from '@angular/router';
import { LayoutDemoComponent } from './components/layout-demo/layout-demo.component';
import { authGuardFn } from '@auth0/auth0-angular';
import { AuthGuard } from './core/auth/auth.guard';

export const routes: Routes = [
    {
        path: 'layout-demo',
        component: LayoutDemoComponent,
    },
    {
        path: 'account',
        loadChildren: () => import('./app-modules/user-account/user-account.routing').then(x => x.UserAccountRoutes),
        canActivate: [],
    },
    {
        path: 'workflow',
        loadChildren: () => import('./app-modules/workflow/workflow.routing').then(x => x.WorkflowRoutes),
        canActivate: [AuthGuard],
    },
    {
        path: 'm',
        loadChildren: () => import('./layouts').then(m => m.MainRoutes),
        canActivate: [AuthGuard],
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'm',
    },
    {
        path: '**',
        redirectTo: 'm',
    },
];
